import deepmerge from 'deepmerge';
import { fade } from '@/uptk/core/packages/style/color_utils';

const createPalette = ({
  type,
  blue30,
  blue400,
  blue500,
  grey20,
  grey90,
  grey100,
  grey600,
  grey900,
  white,
  unknown
}: any) => {
  if (type == 'light') {
    return {
      color1: grey90,
      color2: blue30,
      color3: blue400,
      color4: blue500,
      color5: white,
      color6: grey20,
      unknown
    };
  }
  return {
    color1: grey100,
    color2: fade(blue500, 0.4),
    color3: blue400,
    color4: blue400,
    color5: grey900,
    color6: grey600,
    unknown
  };
};

const createEditable1 = ({
  color1,
  color2,
  color3,
  color4
}: any) => ({
  default: {
    background: 'none',
    borderColor: color1
  },
  active: {
    borderColor: color4
  },
  hover: {
    borderColor: color3,
    indicatorColor: color2
  }
});

const createEditable2 = ({
  color1,
  color2,
  color3,
  color4,
  color5
}: any) => ({
  default: {
    background: color5,
    borderColor: color1
  },
  active: {
    borderColor: color4
  },
  hover: {
    borderColor: color3,
    indicatorColor: color2
  }
});

const createEditable3 = ({
  color1,
  color2,
  color3,
  color4,
  color6
}: any) => ({
  default: {
    background: color6,
    borderColor: color1
  },
  active: {
    borderColor: color4
  },
  hover: {
    borderColor: color3,
    indicatorColor: color2
  }
});

const createGetEditable = (options: any) => ({
  variant = 'editable1',
  density = 'medium',
  state = 'default'
} = {}) => {
  const { hasOwnProperty } = Object.prototype;
  if ( !hasOwnProperty.call(options, variant)) {
    return undefined;
  }
  const variantByDensity = hasOwnProperty.call(options[variant], density)
  ? options[variant][density]
      : {};
  if (state) {
    return variantByDensity[state] || {};
  }
  return variantByDensity;

};

export const createEditable = (palette: any, editable = {}) => {
  const { getEditable: otherGetEditable, ...otherOptions } =
    typeof editable == 'function' ? editable(palette) : editable;

  const editablePalette = createPalette(palette);

  const options = ['touch', 'low', 'medium', 'high'].reduce(
    (result: any, density: string) => ({
      ...result,
      editable1: {
        ...(result.editable1 || {}),
        [density]: createEditable1(editablePalette)
      },
      editable2: {
        ...(result.editable2 || {}),
        [density]: createEditable2(editablePalette)
      },
      editable3: {
        ...(result.editable3 || {}),
        [density]: createEditable3(editablePalette)
      }
    }),
    {}
  );

  const mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  }) as any;

  return {
    getEditable: otherGetEditable || createGetEditable(mergedOptions as any),
    ...(mergedOptions as any)
  };
};
